module.exports = __webpack_public_path__ + "static/specialAOP (1)-b08cce473caa95d0fe0df12369e9aa68.png";